{
  "todayButton": "Vandaag",
  "nextMonth": "Volgende maand",
  "previousMonth": "Vorige maand",
  "nextYear": "Volgend jaar",
  "previousYear": "Vorig jaar",
  "weekdays": [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag"
  ],
  "months": [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december"
  ]
}
